export const auth = {
  login: {
    title: "Iniciar Sesión",
    email: "Email",
    password: "Contraseña",
    submit: "Ingresar",
    noAccount: "¿No tenés una cuenta?",
    registerLink: "Registrate acá",
    success: "Inicio de sesión exitoso",
    error: "Error al iniciar sesión",
    errorMessage: "Por favor, verificá tus credenciales",
    googleButton: "Continuar con Google",
    githubButton: "Continuar con GitHub",
    facebookButton: "Continuar con Facebook",
    twitterButton: "Continuar con Twitter",
  },
  register: {
    title: "Registrarse",
    socialTitle: "Inicio de Sesión Social",
    emailTitle: "Registrarse con Email",
    email: "Email",
    password: "Contraseña",
    firstName: "Nombre",
    lastName: "Apellido",
    submit: "Registrarse",
    hasAccount: "¿Ya tenés una cuenta?",
    loginLink: "Iniciá sesión acá",
    success: "Registro exitoso",
    error: "Error al registrarse",
    errorMessage: "Por favor, intentá nuevamente",
    referralCode: "Registrándose con Código de Referido",
  },
  forgotPassword: "Olvidé mi Contraseña",
  forgotPasswordInstructions:
    "Ingresá tu email y te enviaremos un enlace para restablecer tu contraseña.",
  resetPassword: "Restablecer Contraseña",
  newPassword: "Nueva Contraseña",
  confirmPassword: "Confirmar Contraseña",
  passwordMismatch: "Las contraseñas no coinciden",
  passwordResetSuccess: "Contraseña restablecida exitosamente",
  passwordResetError: "Error al restablecer la contraseña",
  resetEmailSent: "Email de restablecimiento enviado",
  resetEmailError: "Error al enviar el email de restablecimiento",
  sendResetEmail: "Enviar Email de Restablecimiento",
  backToLogin: "Volver a Iniciar Sesión",
  emailVerification: "Verificación de Email",
  verificationSuccess: "Email verificado exitosamente",
  verificationError: "Error en la verificación",
  verificationTokenMissing: "Falta el token de verificación",
  verificationFailed: "Error al verificar el email",
  resendVerification: "Reenviar email de verificación",
  verificationEmailSent: "Email de verificación enviado",
  verificationRequired: "Por favor, verificá tu email",
};
